
import gql from 'graphql-tag'

export const PREMIUM_CONTENT_QUERY = gql`
  query coursesByPartner($partnerName: String!, $subscriberId: Int, $subscriberType: String) {
    coursesByPartner(partnerName: $partnerName, subscriberId: $subscriberId, subscriberType: $subscriberType) {
      name
      description
      isSubscribed
      activities {
        activity {
          id
          name
          slug
          description
          productLine
          publishedAt
          images { url: cardUrl, primary, caption }
        }   
        position
      }
    }
  }
`
export const VALIDATE_ACTIVATION_CODE = gql`
  mutation activateSubscription($subscriberId: Int!, $subscriberType: String!, $activationCode: String!) {
    activateSubscription(
      subscriberId: $subscriberId, 
      subscriberType: $subscriberType, 
      activationCode: $activationCode
    ) {
      status
      errors
      subscription {
        activatedAt,
        activationCode,
        expiredAt,
        id,
        state,
        course {
          sku
        }
        subscriber {
          ... on User {
            email
          }
        }
      }
    }
  }
`

export const GET_EDUCATION_RESOURCES = gql`
  query educationResources($productLine: String!, $robot: String, $language: String) {
    educationResources(productLine: $productLine, robot: $robot, language: $language) {
      category
      description
      educationResourcesGroups {
        position
        asset {
          ... on DocumentLink {
            url
            title
          }
          ... on File {
            url
            title
          }
          ... on Video {
            url
            title
          }
        }
      }
      documentLinks {
        url
        title
      }
      files {
        url
        title
      }
      videos {
        url
        title
      }
      images {
        url: cardUrl
      }
      name
      slug
    }
  }
`
